export default __webpack_public_path__ + "static/media/slider-service.23573ccd.png";